import Config from "../../config/Config";
import {
  createArrayEntityFromObject,
  createQueryUrl,
  getEntity,
} from "../../config/global";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlDev;

export const getNotification = (data) => {
  return new Promise((resolve, reject) => {
    let url = `${baseUrlDev}mob_user/get_notifs?${createQueryUrl(
      getEntity(createArrayEntityFromObject(data), data),
      "&"
    )}`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getNotifData = (page, size) => {
  return new Promise((resolve, reject) => {
    let url =
      baseUrlDev +
      "python/notification?email=" +
      "&phone=" +
      "&page=" +
      page +
      "&size=" +
      size +
      "&sort=createdTime,desc";
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBcData = (page, size) => {
  return new Promise((resolve, reject) => {
    let url = `${baseUrlDev}main_a/broadcast/broadcast/sent?size=${size}&page=${page}&sort=broadcastSent&dir=-1`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBroadcastActive = (status, target) => {
  return new Promise((resolve, reject) => {
    let url = `${baseUrlDev}main_a/broadcast/broadcast/all?status=${status}&target=${target}&size=10&page=0&sort=updateTime&dir=1`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const getBroadcastData = (status, target) => {
  return new Promise((resolve, reject) => {
    let url = `${baseUrlDev}main_a/broadcast/broadcast/all?status=${status}&target=${target}&size=10&page=0&sort=updateTime&dir=1`;
    axios
      .get(url)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
